import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";

export default function AdminNewsletter() {
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/newsletter").then(({ data }) => setItems(data.items || []));
  }, []);

  return (
    <div data-testid="admin-newsletter">
      <h1 className="heading-serif text-4xl text-ink mb-8">{t.admin.newsletter}</h1>
      <div className="bg-white border border-slate200">
        <div className="grid grid-cols-3 px-5 h-10 items-center text-[11px] uppercase tracking-widest text-slate500 border-b border-slate200">
          <div>Email</div>
          <div>Lang</div>
          <div>Date</div>
        </div>
        {items.length === 0 ? (
          <div className="py-12 text-center text-slate500">{t.common.no_results}</div>
        ) : (
          items.map((s) => (
            <div key={s.id} className="grid grid-cols-3 px-5 py-3 text-[13px] border-b border-slate200 last:border-0">
              <div className="text-ink">{s.email}</div>
              <div className="text-slate600 uppercase">{s.lang}</div>
              <div className="text-slate500 text-[12px]">{new Date(s.created_at).toLocaleString()}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
